// @flow

import type { CustomerGroup } from './filter-entity/customer-group'
import type { Region } from './filter-entity/region'
import type { ProductCollection } from './filter-entity/product-collection'
import type { Modality } from './filter-entity/modality'
import type { Term } from './filter-entity/term'

export type FilterSelection = {
  modalities: Modality[],
  customerGroups: CustomerGroup[],
  productCollections: ProductCollection[],
  regions: Region[],
  terms: Term[]
}

export function buildEmptyFilterSelection () {
  return {
    modalities: [],
    customerGroups: [],
    productCollections: [],
    regions: [],
    terms: []
  }
}



// WEBPACK FOOTER //
// ./src/types/filter-selection.js